export function getBlankRecord() {
  return {
    id: null,
    type: null,
    subject: null,
    body: null
  };
}

export function getBlankNextPreviousInfo() {
  return {
    id: null,
    available: false,
    atLimit: false,
    loadPage: false
  };
}

export function getBlankPreviewRecord() {
  return {
    subject: null,
    body: null
  };
}
